var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({staticClass:"icon-font",style:({ fontSize: _vm.size + 'px' }),attrs:{"aria-hidden":"true"}},_vm.$listeners),[_c('use',{attrs:{"xlink:href":`#${_vm.name}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }